import { gql } from '@apollo/client';

export const EXPORT_DSP_EXPENSE_REPORT = gql`
    mutation ExportDspExpenseReport($filters: DspExpenseReportFilterInput) {
        exportDspExpenseReport(filters: $filters) {
            success
            message
            messageKey
            data
        }
    }
`;
